class NHLCollectionToggles extends HTMLElement {
  constructor() {
    super();
    this.toggles = this.querySelectorAll('.nhl-collection-toggles__button');
    this.isMobile = window.innerWidth <= 768;
  }

  connectedCallback() {
    this.initializeDesktopView();
  }

  initializeDesktopView() {
    this.toggles.forEach((toggle, index) => {
      const toggleSection = toggle.closest('.nhl-collection-toggles__item');
      toggleSection.addEventListener('click', this.handleToggleClick.bind(this, toggleSection));
      
      if (index === 0) {
        this.showSection(toggleSection.dataset.section, false);
        toggleSection.classList.add('active');
      } else {
        this.hideSection(toggleSection.dataset.section);
        toggleSection.classList.remove('active');
      }
    });
  }

  handleToggleClick(toggleSection) {
    const sectionToShow = toggleSection.dataset.section;
    
    // Remove active class from all toggle items
    this.querySelectorAll('.nhl-collection-toggles__item').forEach(item => {
      item.classList.remove('active');
    });
    
    // Add active class to clicked toggle item
    toggleSection.classList.add('active');
    
    this.hideSection();
    this.showSection(sectionToShow);

    const productGrids = document.querySelectorAll('.b2b-collection-product-grid');
    const teamSliderItem = document.querySelector('.team-slider__item.selected');
    productGrids.forEach(grid => {
      if (grid.classList.contains('hidden') && teamSliderItem) {
        grid.parentElement.style.display = 'none';
      } else if (grid.classList.contains('active') && teamSliderItem) {
        grid.parentElement.style.display = 'block';
      }
    });
  }

  showSection(section, scroll = true, showParent = false) {
    // Try to find section by ID first
    let sectionToShow = document.querySelector(section);
    
    // If not found by ID, try to find by section name
    if (!sectionToShow && section.startsWith('#')) {
      const sectionName = section.substring(1);
      sectionToShow = document.querySelector(`[data-section-id="${sectionName}"]`) || 
                     document.querySelector(`[id="${sectionName}"]`) ||
                     document.querySelector(`.${sectionName}`);
    }
    
    if (sectionToShow) {
      sectionToShow.classList.add('active');
      sectionToShow.classList.remove('hidden');
      if (showParent) {
        sectionToShow.parentElement.style.display = 'block';
      }
      if (scroll) {
        sectionToShow.scrollIntoView({ behavior: 'smooth' });
      }
    } else {
      console.warn('Section not found:', section);
    }
  }

  hideSection(section) {
    if (section) {
      // Try to find section by ID first
      let sectionToHide = document.querySelector(section);
      
      // If not found by ID, try to find by section name
      if (!sectionToHide && section.startsWith('#')) {
        const sectionName = section.substring(1);
        sectionToHide = document.querySelector(`[data-section-id="${sectionName}"]`) || 
                       document.querySelector(`[id="${sectionName}"]`) ||
                       document.querySelector(`.${sectionName}`);
      }
      
      if (sectionToHide) {
        sectionToHide.classList.remove('active');
        sectionToHide.classList.add('hidden');
      }
    } else {
      const sectionsToHide = document.querySelectorAll('.b2b-collection-product-grid');
      sectionsToHide.forEach(section => {
        section.classList.remove('active');
        section.classList.add('hidden');
      });
    }
  }
}

customElements.define('nhl-collection-toggles', NHLCollectionToggles);